import styled from 'styled-components';

export const EarnMoreCont = styled.div`
  background: linear-gradient(92.91deg, #198a7d 0%, #29b88e 97.89%);
  border: 1px solid #3acca3;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  @media (max-width: 767px) {
    border-radius: 0;
    border: 0;
    padding: 16px;
  }
`;

export const BannerImage = styled.img`
  width: 100%;
  margin-bottom: 16px;
  cursor: ${({isClickable}) => (isClickable ? 'pointer' : 'default')};
`;
export const EarnMoreHeading = styled.h3`
  font-size: 20px;
  line-height: 30px;
  color: #fff;
  font-weight: 900;
`;
export const EarnMoreSubHeading = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  font-weight: 400;
  span {
    font-weight: 700;
  }
`;
export const Note = styled.p`
  font-size: 10px;
`;

export const EarnMoreBody = styled.div`
  background-image: url(images/knowmore-bg.png),
    linear-gradient(90deg, #ffffff -1.32%, #e2f2ff 77.87%);
  background-size: 145px 110px, 100% 100%;
  background-repeat: no-repeat, no-repeat;
  background-position: bottom right, 0 0;
  box-shadow: 0px 4px 8px rgba(138, 107, 118, 0.08);
  border-radius: 8px;
  padding: 20px;
  margin-top: 12px;
  @media (max-width: 767px) {
    padding: 20px 16px;
    background: linear-gradient(90deg, #ffffff -1.32%, #e2f2ff 77.87%);
  }
`;
export const EarnMoreList = styled.ul`
  li {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    @media (max-width: 767px) {
      margin-bottom: 16px;
    }
    p {
      font-size: 14px;
      line-height: 18px;
      span {
        font-weight: 700;
      }
    }
  }
`;
export const EarnMoreListStep = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: #4a4a4a;
  font-weight: 900;
  margin-right: 5px;
  @media (max-width: 767px) {
    width: 28px;
    height: 28px;
    background: #defaf6;
    border: 1px solid #66bdb2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 900;
    color: #1a8c7e;
    flex-shrink: 0;
    margin-right: 8px;
    span {
      display: none;
    }
  }
`;
export const EarnMoreCta = styled.p`
  margin-top: 8px;
  a {
    font-size: 14px;
    font-weight: 900;
    color: #008cff;
  }
  @media (max-width: 767px) {
    padding-left: 36px;
  }
`;
export const HeaderDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
